export const TIPTAP_NODE_VIEW = 'TipTapNodeView';
